import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-24 text-center" data-testid="payment-cancel-page">
        <XCircle className="text-primary" size={52} />
        <h1 className="mt-6 font-serif text-3xl">Payment cancelled</h1>
        <p className="mt-2 text-muted-foreground">No charge was made. You can pick up right where you left off.</p>
        <div className="mt-8 flex gap-3">
          <Link to="/pricing" data-testid="cancel-retry"><Button className="rounded-full bg-primary text-foreground hover:bg-primary/90">Back to pricing</Button></Link>
          <Link to="/courses"><Button variant="outline" className="rounded-full border-border">Browse courses</Button></Link>
        </div>
      </div>
    </div>
  );
}
